// Text of the dashboard: every label that depends on WHAT the account is (a teacher, a coach...) or on a pack lives here,
// by key. The core pack and the category pack each register their own messages (see packs/index.js); a pack's key wins
// over the core's, so "student" can read "member" in a gym without touching a page. Arabic is the default and the
// fallback; English can be added to any pack without changing a page.
let language = "ar";
const registry = { ar: {}, en: {} };

export function registerMessages(messages) {
  Object.keys(messages || {}).forEach((lang) => {
    registry[lang] = Object.assign(registry[lang] || {}, messages[lang]);
  });
}

export function setLanguage(lang) {
  language = registry[lang] ? lang : "ar";
}

export function getLanguage() {
  return language;
}

/** The text for a key in the current language ("{name}" placeholders filled from vars), else Arabic, else the key. */
export function t(key, vars) {
  const own = registry[language] || {};
  let text = own[key] !== undefined ? own[key] : registry.ar[key] !== undefined ? registry.ar[key] : key;
  if (vars) {
    Object.keys(vars).forEach((k) => {
      text = text.split("{" + k + "}").join(vars[k]);
    });
  }
  return text;
}
